import React from 'react';
import '../../cards/cards.css';


function CardWithPictureLeft(props) {
  return (
    <div className='card-grid card-shadow bg-hoiboerzu-dark-One rounded p-4 mb-4'>

      <div className='card-grid-1 card-grid-right'>
        <div>
          <h1>{props.cardTitle}</h1>
        </div>
        <div>
          {props.cardDescription}
        </div>
      </div>

      <div className='card-picture card-grid-left'>
        {props.picture &&
                    <img src={`data:image/png;base64,${props.picture}`} className='card-shadow card-image rounded'
                      alt='Member Picture'/>}
      </div>

    </div>
  );
}

export default CardWithPictureLeft;
